export default __webpack_public_path__ + "static/media/ButtonValidHotel.f2c4a650.png";